import { render } from "./Error.vue?vue&type=template&id=4d91aeba"
import script from "./Error.vue?vue&type=script&lang=ts"
export * from "./Error.vue?vue&type=script&lang=ts"
script.render = render

export default script